<template>
  <div>
    <footer>
      <div class="footer-copyright">
        <div class="layui-container text-center">
          &copy;CIMA，<a href="http://www.beian.miit.gov.cn/" target="_blank">沪ICP备15038274号</a>，<a
            href="https://www.cimaglobal.com/Privacy-Policy/" target="_blank">隐私条款</a>，技术支持：<a
            href="http://www.alawang.com" target="_blank">ALA</a>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import "../../assets/css/footer.css"
export default {
  // 组件参数 接收来自父组件的数据
  props: {},
  // 局部注册的组件
  components: {},
  // 组件状态值
  data() {
    return {}
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
  // 组件方法
  methods: {},
  mounted() {
  },
}
</script>

<style scoped></style>
